import analytics from '../utils/analytics';

class CarouselNav {
  constructor(target, carousel) {
    this.target = target;
    this.carousel = carousel;
    this.buttons = [];
  }

  init() {
    // set listeners
    this.buttons = $(this.target).children('[data-slide]');
    [...this.buttons].forEach((button) => {
      const slide = parseInt($(button).data('slide') ?? 0, 10);
      $(button).on('click', () => {
        this.carousel.goTo(slide);
        let data = {
          title: $(button).text().trim(),
        };
        analytics.gtmClickEvent('carouselClick', data);
      });
    });
    // set event handlers
    this.carousel.setChangeHandler((slide) => {
      this.handleSlideChange(slide);
    });

    window.carouselSetup = true;
  }

  handleSlideChange(slide) {
    $(this.target).find('.active').removeClass('active');
    $(this.target).find(`[data-slide="${slide}"]`).addClass('active');
  }
}

export default CarouselNav;
